import React from 'react';
import { formatMoney, getInvoiceStatus } from '../../../utils';

interface DropdownItemProps<T> {
  item: T;
  displayKey: keyof T;
  onClick: (item: T, event: React.MouseEvent) => void;
  isLoading?: boolean;
}

export const DropdownItem = <T extends { [key: string]: any }>({
  item,
  displayKey,
  onClick,
  isLoading,
}: DropdownItemProps<T>) => {
  // console.log('Item:', item);
  return (
    <div className="p-2">
      {displayKey === 'name' && (
        <div className="flex flex-col">
          <span className="text-sm font-semibold">{item.name}</span>
          <span className="text-xs text-gray-500">{item.phone}</span>
        </div>
      )}
      {displayKey === 'invoiceNumber' && (
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            {isLoading ? (
              <span className="text-sm">Loading...</span>
            ) : (
              <>
                <span className="text-sm font-semibold">{item.customer.firstName} {item.customer.lastName}</span>
                <span className="text-xs font-light">{item.invoiceNumber}</span>
              </>
            )}
          </div>
          <div className="flex flex-col ml-2">
            <span className="text-xs font-light">{formatMoney(item.balanceDue, item.currency)}</span>
            <span className="text-sm">{getInvoiceStatus(item.status)}</span>
          </div>
        </div>
      )}
      {displayKey === 'id' && (
        
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-sm font-semibold">{item?.vendorName}</span>
            <span className="text-xs font-light">{item?.category}</span>
          </div>
          <div className="flex flex-col ml-2">
            {isLoading ? (
              <span>Loading...</span>
            ) : (
              <>
                <span>{formatMoney(item.amount, item.currency)}</span>
                <span>{new Date(item.date).toLocaleDateString()}</span>
              </>
            )}
          </div>
        </div>
      )}
        {/* Default case for rendering the displayKey value */}
        {displayKey !== 'name' && displayKey !== 'invoiceNumber' && displayKey !== 'id' && (
        <span>{item[displayKey]}</span>
      )}
    </div>
  );
};
    

